import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RestaurantStore } from '../../../core/stores/restaurant.store';

@Injectable({
  providedIn: 'root'
})
export class GroupExistGuard implements CanActivate {

  constructor(private restaurantStore: RestaurantStore) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (sessionStorage.getItem('groupId')) {
      this.restaurantStore.groupIdForRedirect = sessionStorage.getItem('groupId');
      this.restaurantStore.backToStorePage();
      return false;
    }
    return true;
  }
}
